import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Paths from './config/Paths';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

if (!window.location.pathname.startsWith(Paths.BasePath)) {
    window.location.href = `/Error/404`;
}
root.render(
  <BrowserRouter basename={Paths.Basename}>
    <App />
  </BrowserRouter>,
);

registerServiceWorker();
